module.exports = __webpack_public_path__ + "static/media/logo.9be532e7.png";